import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from 'src/app/api.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-enter-stage',
  templateUrl: './enter-stage.component.html',
  styleUrls: ['./enter-stage.component.scss']
})
export class EnterStageComponent implements OnInit {

  todayDate: Date = new Date();
  jarvisData: any = [];
  stages: any = [];
  agencyData: any = [];
  jobID: number = 0;
  jobDetails: any = null;
  stage: any = {
    stageName: '',
    sid: '',
    target: this.todayDate,
    instruction: ''
  }
  stageData: any;
  @Input() mdlRef: any;

  constructor(private modalService: NgbModal, private dataService: DataService, private apiService: APIService) { }
  
  ngOnInit(): void {

    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    };

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    this.dataService.productStages.subscribe((value: any) => {
      this.stages = value.filter((stage: any) => !stage.SDT);
      // this.stages = this.stages.sort((a: any, b: any) => String(a.Seq).localeCompare(String(b.Seq)));

      this.stages = this.stages.sort((a: any, b: any) => a.Seq - b.Seq);
    })
    this.stage.sid = this.stageData.SID ? this.stageData.SID : 0;
    this.stage.target = this.stageData.TDT ? this.stageData.TDT : new Date();
    this.stage.instruction = this.stageData.IN ? this.stageData.IN : '';
    this.stage.stageName = this.stageData.SNm ? this.stageData.SNm : '';
  }

  addStage() {
    if (this.stage.sid == '') {
      this.apiService.successAlert('Please select stage.');
      return;
    }
    
    let stageName = this.stages.find((stage: any) => stage.SID == this.stage.sid)?.SNm || '';
    if (stageName == '') {
      this.apiService.successAlert('Invalid stage selected.');
      return;
    }

    let myLastSyncDT = localStorage.getItem("MyLastSyncDT");
    

    var tempData = [{
      'JobID': this.jobID,
      'NewStageID': this.stage.sid,
      'NewStage': stageName,
      'targetDT': new Date(this.stage.target).customFormat("#DD#-#MMM#-#YY#"),
      'Notes': this.stage.instruction,
      'Generation': JSON.stringify(this.jobDetails.generation),
      'Consumption': JSON.stringify(this.jobDetails.consumption),
      'Rejection': JSON.stringify(this.jobDetails.rejection),
      'changeType': 'PRJADD',
      'prdTypeID': 2
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: myLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'MoveJob',
      moduleID: 7,
      data: JSON.stringify(tempData)
    }];

    this.apiService.sendChange(myParams, this.successAddStage.bind(this), this.failureAddStage.bind(this));

  }

  successAddStage(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode != -1) {
          alert(reponseData.Table[0].ErrMsg);
        }
        else {
          const data = reponseData.Table[0];
          const stages = data.Stages;
          let doneObj: any = {
            action: 'Done',
            stages: stages
          }
          this.closeModal(doneObj);
        }
      }
    }
  }

  failureAddStage() {

  }

  closeModal(obj: any) {
    this.mdlRef.close(obj);
  }
}
